// Import the new enhanced currency formatter
import { formatCurrency as enhancedFormatCurrency } from './currencyFormatter';

// Keep backward compatibility
export const formatCurrency = (amount) => {
  return enhancedFormatCurrency(amount);
}; 